import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customerService, walletTransferService } from "@/services/customerService";
import type { CustomerKycDto, WalletTransferDto } from "@/types/customer.dto";
import { queryKeys } from "./keys";

export function useMemberProfile() {
  return useQuery({
    queryKey: queryKeys.customer.member,
    queryFn: () => customerService.getMemberProfile(),
  });
}

export function useUserCoupons() {
  return useQuery({
    queryKey: queryKeys.customer.coupons,
    queryFn: () => customerService.getCoupons(),
  });
}

export function useSubmitKycMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dto: CustomerKycDto) => customerService.submitKyc(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.customer.member });
    },
  });
}

export function useActivateMemberMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => customerService.activateMember(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.customer.member });
      queryClient.invalidateQueries({ queryKey: queryKeys.customer.coupons });
    },
  });
}

export function useP2pTransferMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dto: WalletTransferDto) => walletTransferService.transfer(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.wallets.my });
      queryClient.invalidateQueries({ queryKey: ["wallets"] });
    },
  });
}
